"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var Definition = /** @class */ (function () {
    function Definition() {
    }
    return Definition;
}());
exports.Definition = Definition;
;
var DefinitionBuilder = /** @class */ (function (_super) {
    __extends(DefinitionBuilder, _super);
    function DefinitionBuilder(definition) {
        var _this = _super.call(this) || this;
        Object.assign(_this, definition);
        return _this;
    }
    DefinitionBuilder.prototype.addReducers = function (reducers) {
        return new DefinitionBuilder(__assign({}, this, { reducers: __assign({}, this.reducers, reducers) }));
    };
    DefinitionBuilder.prototype.addActionCreators = function (actions) {
        return new DefinitionBuilder(__assign({}, this, { actions: __assign({}, this.actions, actions) }));
    };
    DefinitionBuilder.prototype.defineSlice = function (name, definition) {
        var _a;
        return new DefinitionBuilder(__assign({}, this, { combines: __assign({}, this.combines, (_a = {}, _a[name] = definition, _a)) }));
    };
    DefinitionBuilder.prototype.setDefault = function (value) {
        return new DefinitionBuilder(__assign({}, this, { default: value, hasDefault: true }));
    };
    DefinitionBuilder.prototype.use = function (plugin) {
        return plugin(this);
    };
    return DefinitionBuilder;
}(Definition));
exports.DefinitionBuilder = DefinitionBuilder;
;
function definition() {
    return new DefinitionBuilder({
        hasDefault: false,
        default: undefined
    });
}
exports.definition = definition;
var listBase = function (collectionDefinition, defaultValue) {
    return new DefinitionBuilder({
        hasDefault: true,
        default: defaultValue,
        list: collectionDefinition
    });
};
exports.list = function (collectionDefinition) {
    return listBase(collectionDefinition, []);
};
exports.nullableList = function (collectionDefinition, defaultValue) {
    return listBase(collectionDefinition, defaultValue);
};
exports.combine = function (slices) {
    return new DefinitionBuilder({
        hasDefault: true,
        default: util_1.mapValues(slices, function (slice) { return slice.default; }),
        combines: slices
    });
};
